import React, { useMemo } from 'react'
import { Icon } from '@crossfit/ui'

import { Score } from 'pages/Programming/types'
import style from './style.module.css'

type Props = {
  children: Score
}

function ScoreTag({ children }: Props) {
  const text = useMemo(() => {
    switch (children) {
      case Score.Time:
        return 'Total time'
      case Score.Load:
        return 'Load'
    }
  }, [children])

  const icon = useMemo(() => {
    switch (children) {
      case Score.Time:
        return 'stop-watch' as const
      case Score.Load:
        return 'load'
    }
  }, [children])

  if (!text) {
    return null
  }

  return (
    <div className={style.wrapper}>
      <span className={style.label}>Score:&nbsp;</span>
      <span className={style.value}>{text}</span>{' '}
      <Icon name={icon} className={style.icon} />
    </div>
  )
}

export default ScoreTag
